import Commons from '../../../../Services/Common/Common';

export const M_TBG_CUSTOM_08_Schema = {
  fields: {
    tbmTitle: { initial: '', label: '제목', required: 'Y' },
    tbmComment: { initial: '', label: '내용', required: 'Y' },
    tbmAddress: { initial: '', label: '장소', required: 'Y' },
    photoNm: { initial: '', label: '', },
    photoImg: { initial: null, label: '' },
    photoSrc: { initial: '', label: '' },
    signPath: { initial: '', label: '' },
  },
  mapper: {
    save1: {
      TbmCd: (row) => Commons.EncryptAES(row.tbmCd ?? '') || '',
      UserId: (_, context) => context.userInfo?.userid ?? '',
      TbmTitle: (row) => Commons.EncryptAES(row.tbmTitle ?? '') || '',
      TbmComment: (row) =>
        Commons.EncryptAES(row.tbmComment ?? '') || '',
      TbmPhoto: (row) => Commons.EncryptAES(row.tbmPhoto),
      TbmAddress: (row) =>
        Commons.EncryptAES(row.tbmAddress ?? '') || '',
      SignPath: (row) =>
        Commons.EncryptAES(row.signPath ?? '') || '',
    },
    save2: {
      TbmCd: (row) => Commons.EncryptAES(row.tbmCd ?? '') || '',
      UserId: (_, context) => context.userInfo?.userid ?? '',
    },
    save3: {
      TbmCd: (row) => Commons.EncryptAES(row.tbmCd ?? '') || '',
      EStep: (row) => Commons.EncryptAES(String(row.eStep ?? '')) || '',
      MStep: (row) => Commons.EncryptAES(String(row.mStep ?? '')) || '',
      UserId: (_, context) => context.userInfo?.userid,
    },
  },
};
